export default "__VITE_ASSET__Blq$zQ9K__"